import React from "react";
import PropTypes from "prop-types";
import chevronLeftIcon from "../../assets/img/property-config/pagination-chevron-left.svg";
import chevronRightIcon from "../../assets/img/property-config/pagination-chevron-right.svg";
import chevronLeftIconDisabled from "../../assets/img/property-config/pagination-chevron-left-disabled.svg";
import chevronRightIconDisabled from "../../assets/img/property-config/pagination-chevron-right-disabled.svg";
import { generatePageNumbers } from "./tableUtils";
import "./propertyConfigPagination.scss";

const PropertyConfigPagination = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  if (totalPages <= 1) return null;

  const pages = generatePageNumbers(currentPage, totalPages);
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalPages;

  return (
    <div className="property-config-table-pagination">
      <button
        type="button"
        className={`property-config-table-pagination__btn${
          isFirstPage ? " property-config-table-pagination__btn--disabled" : ""
        }`}
        onClick={isFirstPage ? undefined : () => onPageChange(currentPage - 1)}
        disabled={isFirstPage}
        aria-label="Previous page"
      >
        <img
          src={isFirstPage ? chevronLeftIconDisabled : chevronLeftIcon}
          alt=""
          className="property-config-table-pagination__btn-icon"
        />
        Previous
      </button>

      <div className="property-config-table-pagination__pages">
        {pages.map((page, index) =>
          page === "..." ? (
            <span
              key={`ellipsis-${index}`}
              className="property-config-table-pagination__ellipsis"
            >
              ...
            </span>
          ) : (
            <button
              key={page}
              type="button"
              className={`property-config-table-pagination__page-btn${
                page === currentPage
                  ? " property-config-table-pagination__page-btn--active"
                  : ""
              }`}
              onClick={
                page === currentPage ? undefined : () => onPageChange(page)
              }
              aria-label={`Page ${page}`}
              aria-current={page === currentPage ? "page" : undefined}
            >
              {page}
            </button>
          )
        )}
      </div>

      <button
        type="button"
        className={`property-config-table-pagination__btn${
          isLastPage ? " property-config-table-pagination__btn--disabled" : ""
        }`}
        onClick={isLastPage ? undefined : () => onPageChange(currentPage + 1)}
        disabled={isLastPage}
        aria-label="Next page"
      >
        Next
        <img
          src={isLastPage ? chevronRightIconDisabled : chevronRightIcon}
          alt=""
          className="property-config-table-pagination__btn-icon"
        />
      </button>
    </div>
  );
};

PropertyConfigPagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default PropertyConfigPagination;
